<template>
  <div class="ccs-layout">
    <div class="ccs-layout css-12 ccs-layout--no-pad">
      <ccs-input class="ccs-4" v-model.trim="fieldsValues.last_name"
        v-bind="fieldsDefinitions.last_name" @error="(err) => setFieldError('last_name', err)"/>
      <ccs-input class="ccs-4" v-model.trim="fieldsValues.first_name"
        v-bind="fieldsDefinitions.first_name" @error="(err) => setFieldError('first_name', err)"/>
      <ccs-input class="ccs-4" v-model.trim="fieldsValues.email"
        v-bind="fieldsDefinitions.email" @error="(err) => setFieldError('email', err)"/>
      <ccs-input class="ccs-4" v-if="!isEditing" v-model.trim="fieldsValues.role_id"
        v-bind="fieldsDefinitions.role_id" :items="rolesForSelect"
        @change="onRoleSearch" @error="(err) => setFieldError('role_id', err)"/>
      <ccs-input class="ccs-4" v-if="!isEditing" v-model.trim="fieldsValues.password"
        v-bind="fieldsDefinitions.password" @error="(err) => setFieldError('password', err)"/>
      <ccs-input class="ccs-4" v-if="!isEditing" v-model.trim="fieldsValues.password_confirm"
        v-bind="fieldsDefinitions.password_confirm" @error="(err) => setFieldError('password_confirm', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить изменения
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';
import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'User',
  mixins: [AutocompleteParent, FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        first_name: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Имя",
          placeholder: "Введите имя",
        },
        last_name: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Фамилия",
          placeholder: "Введите фамилию",
        },
        email: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Email",
          placeholder: "Введите email",
        },
        role_id: {
          isValid: false,
          error: '',
          required: false,
          type: "autocomplete",
          label: "Роль",
          placeholder: "Введите 3 символа для поиска",
        },
        password: {
          isValid: false,
          error: '',
          required: true,
          type: "password",
          label: "Пароль",
          placeholder: "Введите пароль",
        },
        password_confirm: {
          isValid: false,
          error: '',
          required: true,
          type: "password",
          label: "Повторите пароль",
          placeholder: "Повторите пароль",
        },
      },
      fieldsValues: {
        first_name: '',
        last_name: '',
        email: '',
        role_id: null,
        password: '',
        password_confirm: '',
      },
      rolesForSelect: [],
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    isEditing() {
      return this.$props.data && this.$props.data.id;
    }
  },
  methods: {
    ...mapActions('users', ['createUser', 'updateUser']),
    async onRoleSearch(text) {
      [this.rolesForSelect] = await this.getAutocompleteData('/v1/roles/list', text);
    },
    async submit() {
      this.validateForm();
      if (this.isFormValid) {
        if (this.fieldsValues.id) {
          await this.editUser();
        } else {
          await this.addUser();
        }
      }
    },
    async addUser() {
      if (this.fieldsValues.password !== this.fieldsValues.password_confirm) {
        this.$toasted.error('Пароли не совпадают');
        this.setFieldError('password', 'Пароли не совпадают');
        this.setFieldError('password_confirm', 'Пароли не совпадают');
        return;
      }
      try {
        await this.createUser(this.fieldsValues);
        this.$toasted.success('Пользователь добавлен');
        this.$emit('close');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
    async editUser() {
      try {
        const changedFields = this.getChangedFields({
          ...this.$props.data,
          password: '',
          password_confirm: '',
        });
        if (Object.keys(changedFields).length > 0){
          await this.updateUser({
            ...changedFields,
            id: this.fieldsValues.id,
          });
          this.$toasted.success('Изменения сохранены');
        }
        this.$emit('close');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
  },
  mounted() {
    if (this.$props.data && this.$props.data.id) {
      this.fieldsValues = Object.assign({}, this.$props.data);
      this.fieldsDefinitions.password.required = false;
      this.fieldsDefinitions.password_confirm.required = false;
    }
  },
}
</script>